/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from 'semantic-ui-react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left">
                <List>
                  <List.Header>
                    <h4>About JET</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about-jet/the-jet-story">
                        The JET Story
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/board-of-directors">
                        Our Board
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/team">
                        Our Team
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/annual-reports">
                        Annual Reports
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/alliances">
                        Alliances
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/vacancies-at-jet">
                        Vacancies at JET
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/frequently-asked-questions">
                        FAQs
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left">
                <List>
                  <List.Header>
                    <h4>What we do</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/work">Our Work</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/news">News</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/projects/all-projects">
                        Projects
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/resources">Resources</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/unevoc">UNEVOC</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left">
                <List>
                  <List.Header>
                    <h4>Quick Links</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/contact">Contact Us</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="/siteworkspace/fraud-hotline.pdf/@@download/file"
                        target="_blank"
                      >
                        Fraud Hotline
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/contact">
                        Join our mailing list
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about-jet/privacy-policy">
                        Privacy Policy
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="/siteworkspace/annexure-aa-intellectual-property-policy-docx.pdf/@@download/file"
                        target="_blank"
                      >
                        Intellectual Property Policy
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item>
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/JETEdServices"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.threads.com/@jetedservices"
                            target="_blank"
                            title="Threads"
                          >
                            <i class="bi bi-threads"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/channel/UCgu7w-Eel-dMP2lLLvl91-g"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.instagram.com/jetedservices/"
                            target="_blank"
                            title="Instagram"
                          >
                            <i class="bi bi-instagram"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/jet-education-services/"
                            target="_blank"
                            title="LinkedIn"
                          >
                            <i class="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item>
                      <FormattedMessage
                        id="{copyright} jet {current_year}"
                        defaultMessage="{copyright} JET Education Services {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-circle-fill"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
